import { useContext } from 'react';
import FeatureFlagProps from '../../FeatureFlagProps';
import { CrmisFeatureFlagsContext } from '../CrmisFeatureFlagsContext';
import ShowFeature from './ShowFeature';

const ShowFeatureWithContext = ({
  children,
  flagsToBeTruthy = [],
  Loader = null
}: FeatureFlagProps): JSX.Element | null => {
  const { featureFlags, loading } = useContext(CrmisFeatureFlagsContext);

  return loading || !featureFlags
    ? <>{Loader}</>
    : <ShowFeature flagsToBeTruthy={flagsToBeTruthy} allFeatureFlags={featureFlags}>
      {children}
    </ShowFeature>;
}

export default ShowFeatureWithContext;
